import type { OrderFragment } from '#graphql-operations'

export function getSurchargesForOrderLine(order: OrderFragment, orderLineId: string | number): OrderFragment['surcharges'] {
  return order.surcharges.filter(surcharge => surcharge.orderLineId === orderLineId) || []
}
